<template>
  <div class="nb-root">
    <div v-if="showLanguage" class="nb-lang">{{ message.language }}</div>
    <div class="nb-chat">
      <div class="nb-bubble">
        <media-preview
          v-if="message.headerMedia"
          :format="message.headerMedia.format"
          :media-id="message.headerMedia.mediaId"
          :media-name="message.headerMedia.mediaName || ''"
          :file-name="message.headerMedia.fileName || ''"
          :country-id="message.headerMedia.countryId"
          :language-id="message.headerMedia.languageId"
        />
        <div v-if="message.header" class="nb-header">{{ message.header }}</div>
        <div class="nb-body">{{ message.body || 'No message text saved for this language.' }}</div>
        <div v-if="message.footer" class="nb-footer">{{ message.footer }}</div>
      </div>
      <div v-for="b in message.buttons" :key="b" class="nb-button">{{ b }}</div>
    </div>
    <div class="nb-src">
      {{ message.source === 'template' ? `Approved template: ${message.templateName}` : 'Saved message text, no approved template attached' }}
    </div>
  </div>
</template>

<script>
import MediaPreview from '../../common/MediaPreview.vue'

// One nudge as the user receives it, in one language. `message` is a
// preview.groups[].languages[] entry from nudge-campaign-analytics-detail.
export default {
  name: 'nudge-bubble',
  components: { MediaPreview },
  props: {
    message: { type: Object, required: true },
    showLanguage: { type: Boolean, default: true }
  }
}
</script>

<style scoped>
.nb-lang {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #98a2b3;
  margin-bottom: 5px;
}

/* A WhatsApp-style thread: the colours are the app's, not the page's, so it reads as the
   message rather than as dashboard chrome. */
.nb-chat {
  background: #e5ddd5;
  border-radius: 10px;
  padding: 12px;
}

.nb-bubble {
  background: #fff;
  border-radius: 0 8px 8px 8px;
  padding: 8px 10px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
  font-size: 13px;
  color: #101828;
}

.nb-header { font-weight: 700; margin-bottom: 3px; }
.nb-body { white-space: pre-wrap; word-break: break-word; }
.nb-footer { color: #8696a0; font-size: 11px; margin-top: 4px; }

.nb-button {
  background: #fff;
  border-radius: 8px;
  margin-top: 4px;
  padding: 7px;
  text-align: center;
  color: #027eb5;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
}

.nb-src { font-size: 11px; color: #98a2b3; margin-top: 5px; }
</style>



// WEBPACK FOOTER //
// NudgeBubble.vue?49ad6cc6